const languageObj = {
  'AI Face Animator': 'تأثيرات الوجه AI',
  'Create incredible facial expressions with brainwashing music, find the magic for fun.': 'تعابير سحرية ، وموسيقى غسيل دماغ ، استمتع بالمتعة الساخنة.',
  'Upload a photo': 'حمل الصورة',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.': 'ملاحظة: يرجى التأكد من أن الوجه في الصور التي حددتها يواجه العدسة ، وإلا فلن تتمكن من معالجته بنجاح.',
  'Uploaded successfully!': 'تم الرفع بنجاح!',
  'Please select a template below': 'الرجاء تحديد قالب أدناه',
  'Choose a GIF': 'اختر ملف GIF',
  'Use this template': 'استخدم هذا النموذج',
  'Verify successfully! You will': 'تحقق بنجاح! سوف تتلقى الفيديو مع {{email}} قريبا.',
  'You will': 'سوف تتلقى الفيديو مع {{email}} قريبا.',
  'What you should expect to happen next': 'ما يجب أن تتوقع حدوثه بعد ذلك:',
  'We will process your photo into a dynamic video.': 'سنعالج صورتك في فيديو ديناميكي.',
  'After processing, we will send the video to your email.': 'بعد المعالجة ، سنرسل الفيديو إلى بريدك الإلكتروني.',
  'You can check the video in your email.': 'يمكنك التحقق من الفيديو في بريدك الإلكتروني.',
  'Your video will be delivered via email': 'بعد المعالجة ، سنرسل الفيديو إلى بريدك الإلكتروني.',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.': 'يستغرق الأمر من 20 إلى 30 دقيقة لتجميع مقطع فيديو ديناميكي ، يرجى التحلي بالصبر. لحماية خصوصيتك ، سيتم حذف الصور التي تم تحميلها تلقائيًا بعد انتهاء المعالجة.',
  'Your Email': 'بريدك الالكتروني',
  'Last Name': 'الاسم الأول',
  'First Name': 'اسم العائلة',
  'Go back': 'رجع',
  'Invalid email address':'عنوان البريد الإلكتروني غير صالح',
  'Enter verification code':'أدخل رمز التحقق',
  'Enter the verification code that we sent to': 'أدخل رمز التحقق الذي أرسلناه إلى {{email}}.',
  'Resend': 'إعادة إرسال',
  'Verification code': 'رمز التحقق',
  'Resend after': '{{num}}إعادة الإرسال بعد s',
  'The verification code is invalid. You can request a new one.': 'رمز التحقق غير صالح. يمكنك طلب واحدة جديدة.',
  'Synthesize Video': 'تجميع الفيديو',
  'Too many attempts, please try again later.': 'محاولات كثيرة. الرجاء معاودة المحاولة في وقت لاحق.'
}
export default languageObj